import { render } from "./sessionDelete.vue?vue&type=template&id=99d73ecc&scoped=true"
import script from "./sessionDelete.vue?vue&type=script&lang=js"
export * from "./sessionDelete.vue?vue&type=script&lang=js"

import "./sessionDelete.vue?vue&type=style&index=0&id=99d73ecc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99d73ecc"]])

export default __exports__